import { RouteRecordRaw } from 'vue-router';
import combineGuards from '@/router/guards/helpers';
import { requireSeeker } from '@/router/guards/authGuards';
import { checkPremiumParentRegistration } from '@/router/guards/completionGuards';
import { checkMessagingCreateEligibility } from '@/router/guards/messagesGuards';
import MessagesNew from '@/apps/messages/new/MessagesNew.vue';

const messagesNewRoutes: RouteRecordRaw[] = [
  {
    path: '/messages/new',
    name: 'MessagesNew',
    component: MessagesNew,
    beforeEnter: combineGuards([requireSeeker, checkMessagingCreateEligibility, checkPremiumParentRegistration]),
  },
];

export default messagesNewRoutes;
